const Animation = {
  //Criando arquivo de estilo para animações
  createAnimationStyles: function () {
    /**
     * Função que cria os estilos para as animações
     */

    // Cria um elemento 'style'
    let style = document.createElement("style");
    // style.id = 'californio-animation-styles';

    // Define o conteúdo do elemento 'style'
    style.innerHTML = `
        .californio-animation {
          opacity: 0;
          transform: translateY(20px);
          transition: opacity 0.6s ease-out, transform 0.6s ease-out;
        }

        .californio-animation.animate {
          opacity: 1;
          transform: translateY(0);
        }

        .californio-animation.from-left {
          transform: translateX(-20px);
        }

        .californio-animation.from-right {
          transform: translateX(20px);
        }

        .californio-animation.from-top {
          transform: translateY(-20px);
        }

        .californio-animation.from-bottom {
          transform: translateY(20px);
        }

        .californio-animation.from-left.animate,
        .californio-animation.from-right.animate {
          transform: translateX(0);
        }

        .californio-animation.from-top.animate,
        .californio-animation.from-bottom.animate {
          transform: translateY(0);
        }
      `;

    // Anexa o elemento 'style' ao 'head' do documento
    document.head.appendChild(style);
  },

  // Listener de para verificar se elemento está visível na tela usando intersection Observer
  onScreen: function (element, callback) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            callback();
            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.3,
      },
    );

    observer.observe(element);
  },

  // Seleciona os elementos com a classe californio-animation
  selectAnimationElements: function () {
    return Array.from(document.querySelectorAll(".californio-animation"));
  },

  // Inicializa as animações
  initAnimations: function () {
    const elements = this.selectAnimationElements();
    elements.forEach((element) => {
      this.onScreen(element, () => {
        element.classList.add("animate");
      });
    });
  },

  init: function () {
    let _this = this;

    // this.createAnimationStyles();
    this.initAnimations();
  },
};

export default Animation;
